import type { MiscellaneousFeatures } from '../types/MiscellaneousFeatures';
import type { RetailOnlyFeatures, RetailOnlyShorthandFeatures } from '../types/RetailOnlyFeatures';

export const features: RetailOnlyFeatures = {
    favorites: {
        enabled: true,
        _description:
            'Enables marking transactions as favorite. Disable this flag to discontinue the feature.',
    },
    claims: {
        enabled: false,
        _description: `
            Enables ticketing service for claimable transactions.
            (Surfaced through a button in Transaction Details.)
        `,
    },
    useSharedModuleForExport: {
        enabled: false,
        _description: `
            Use the new Export feature implementation from the shared modules.
        `,
    },
    postalConfirmation: {
        enabled: false,
        _description: `
            Enables a button in the transaction details to request postal confirmation.
        `,
    },
    retrievable: {
        enabled: false,
        _description: `
            Enables ticketing service for mistakenly placed transactions.
            (Surfaced through a button in Transaction Details.)
        `,
    },
    instantPaymentLogo: {
        enabled: false,
        _description: `
          Enables instant payment logos in transaction details.
        `,
    },
    redoAndReply: {
        enabled: true,
        _description: 'Enables the redo and reply buttons actions in the transaction detail.',
    },
};

export const shorthandFeatures: RetailOnlyShorthandFeatures = {
    monthGroup: {
        enabled: true,
        _description: `Groups transactions by month in Credit Card history,
            overriding otherwise preferred invoice numbers.`,
    },
};

export const miscellaneous: MiscellaneousFeatures = {
    IS_RETRIEVABLE: {
        enabled: false,
        _description: `
            Enables ticketing service for mistakenly placed transactions.
            (Surfaced through a button in Transaction Details.)

            NB: This flag should eventually become \`transactions.retrievable\`.
        `,
    },
};
